import React from "react";
import SuccessErrorMessage from "../../MessageBox/SuccessErrorMessage";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { GiGears } from "react-icons/gi";
import { useState } from "react";
import AddEquipment from "./AddEquipment";

const EquipmentList = () => {
  const [equipmentNameList, setEquipmentNameList] = useState([]);
  const [equipmentDetails, setEquipmentDetails] = useState("");
  const { localization } = useLanguageContext();

  //------------------------Get Equipment start ----------------------
  //------------------------Get Equipment end ----------------------

  //------------------------Add or update Equipment start ----------------------

  function RenderAddEquipment() {
    return (
      <>
        <GiGears
          title="Add Equipment"
          className="svgIcon cursorPoint"
          size={27}
          onClick={() => {
            setEquipmentDetails("");
          }}
          data-toggle="modal"
          data-target="#addEquipment"
        />
      </>
    );
  }
  //------------------------Add or update Equipment end ----------------------

  //------------------------Edit Equipment start ----------------------
  // logic

  const setCurrentEquipmentDetails = (row) => {
    setEquipmentDetails(row);
  };

  function RenderEditButton(props) {
    const currentEquipment = props.currentEquipment;
    return (
      <>
        <AiOutlineEdit
          className="mr-4 svgIcon cursorPoint"
          title="Edit Equipment "
          size={20}
          onClick={() => {
            setCurrentEquipmentDetails(currentEquipment);
          }}
          data-toggle="modal"
          data-target="#addEquipment"
        />
      </>
    );
  }

  //------------------------Edit Equipment end ----------------------

  //------------------------Delete Equipment start ----------------------
  //------------------------Delete Equipment end ----------------------

  return (
    <>
      <div
        style={{ height: "100%", width: "100%", overflow: "auto" }}
        id="content"
      >
        <SuccessErrorMessage
        // showmessage={showmessage}
        // message={message}
        // isSuccess={issuceess}
        // funct={resetSuccessErrorMessage}
        />
        <div className="pt-4 px-3 d-flex justify-content-between">
          <h3>{localization.equipment}</h3>
          <RenderAddEquipment />
        </div>
        <div className="form-group d-flex col-lg-3 align-items-center">
          {/* <select
						className="form-control"
						id="plantList"
						name="plantList"
						required
						value={plantId}
						onChange={(e) => {
							setPlantId(e.target.value);
						}}
					>
						{plantList.map((row, index) => {
							return (
								<option key={index} value={row.id}>
									{row.bezeichnung}
								</option>
							);
						})}
					</select> */}
        </div>
        <div className="table-responsive px-3" style={{ maxHeight: "70vh" }}>
          <table className="table align-middle mb-0 table-striped table-hover table-sticky">
            <thead className="bg-light">
              <tr>
                <th>{localization.equipmentName}</th>
                <th>{localization.action}</th>
              </tr>
            </thead>
            {/* <tbody>
							{equipmentNameList.length == 0 ? (
								<tr>
									<td className="text-center" colSpan={100}>
									
									</td>
								</tr>
							) : (
								equipmentNameList.map((row, index) => {
									return (
										<tr key={index}>
											<td>
												<p className="fw-bold mb-1">{row.kost} </p>
												<p>Equipment Name</p>
											</td>
											<td>
												<div className="d-flex">
													<AiOutlineEdit />

													<AiOutlineDelete />
												</div>
											</td>
										</tr>
									);
								})
							)}
						</tbody> */}
            <tbody>
              <tr>
                <td>
                  <p>{localization.equipmentName}</p>
                </td>
                <td>
                  <div className="d-flex">
                    <RenderEditButton />

                    <AiOutlineDelete />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <AddEquipment />
    </>
  );
};

export default EquipmentList;
